/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import SvgVolume from './SvgVolume';
import { changeVolumeAction } from '../../redux/actions';
import './index.css';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    height: '100px',
    left: 0,
    bottom: '20px',
  },
  colorPrimary: {
    color: '#000000',
  },
  thumb: {
    '&:hover, &:focus ,&:active': { boxShadow: 'none' },
  },
});

function Volume({ changeVolume, volume }) {
  const classes = useStyles();
  const [value, setValue] = useState(100);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    changeVolume(newValue / 100);
  };
  useEffect(() => {
    changeVolume(1)
    }, []
  );
  return (
    <div className="volume-container">
      <div className="volume-container__item">
        <div className="volume-container__range-wrapper">
          <div className="volume-container__range-container">
            <Slider
              min={0}
              max={100}
              classes={classes}
              color="primary"
              value={value}
              onChange={handleChange}
              orientation="vertical"
              aria-label="Temperature"
            />
          </div>
        </div>
        <div className="volume-container__icon-container">
          <SvgVolume />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  volume: state.volume,
});

const mapDispatchToProps = {
  changeVolume: changeVolumeAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Volume);
